import React from "react";
import PropTypes from "prop-types";
import { OrcaWrapper } from "./OrcaWrapper";
import { OrcaLoopingUI } from "./OrcaLoopingUI";

export const LoopingPlayer = ({ config, onVideoRendered, orcaRef }) => {
  return (
    <OrcaWrapper config={config}>
      <OrcaLoopingUI
        onVideoRendered={onVideoRendered}
        config={config}
        handleVideoEnd={() => {}}
        ref={orcaRef}
      />
    </OrcaWrapper>
  );
};

LoopingPlayer.propTypes = {
  config: PropTypes.object.isRequired,
  isSandbox: PropTypes.bool,
  onVideoEnded: PropTypes.func,
  promoEnabled: PropTypes.bool,
  onVideoRendered: PropTypes.func,
  orcaRef: PropTypes.object
};
